const React = require('react');
const classNames = require('classnames');
const PropTypes = require('prop-types');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { StarsRating } = require('commonsComponents/starsRating');

class StarCheckbox extends React.Component {

    render() {
        const { idName, stars, value, onChange, extraClass } = this.props;
        const className = classNames('stars-checkbox', extraClass);
        const filledStars = value ? stars : 0;
        return (
            <div className={className}>
                <OKCheckbox
                    idName={idName}
                    value={value}
                    onChange={onChange}
                    label={<StarsRating total={stars} actual={filledStars}/>}
                />
            </div>
        );
    }
}

StarCheckbox.propTypes = {
    idName: PropTypes.string.isRequired,
    stars: PropTypes.number,
    value: PropTypes.bool,
    extraClass: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = StarCheckbox;
